var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.baseClass},[(_vm.noResults)?_c('ToolReportingNoResults',{class:`${_vm.baseClass}__no-results`,style:({ justifyContent: _vm.justifyContentStyle })}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }